import { createReducer, on } from '@ngrx/store';
import { OrganizationInvitationsState } from '../../models/organizations/invitations.model';
import * as OrganizationsActions from '../../actions/organizations/invitations.actions';
import * as AuthActions from '../../actions/auth.actions';

export const initialOrganizationInvitationsState: OrganizationInvitationsState = {
  invitationsByOrgId: {},
  invitationResentAtByOrgId: {},
  invitationByOrgAndId: {}
};

export const organizationInvitationsReducer = createReducer(
  initialOrganizationInvitationsState,

  on(OrganizationsActions.loadOrganizationInvitationsSuccess, (state, { organizationId, invitations }) => ({
    ...state,
    invitationsByOrgId: {
      ...state.invitationsByOrgId,
      [organizationId]: invitations
    }
  })),

  on(OrganizationsActions.addOrInviteOrganizationUserSuccess, (state, { organizationId, invitation, invitationSent }) => {
    if (!invitationSent || !invitation) return state;
    
    const prev = state.invitationsByOrgId?.[organizationId] || [];
    const invitationId = invitation.id as string;
    
    return {
      ...state,
      invitationsByOrgId: {
        ...state.invitationsByOrgId,
        [organizationId]: [...prev, invitation]
      },
      invitationByOrgAndId: {
        ...state.invitationByOrgAndId,
        [organizationId]: {
          ...(state.invitationByOrgAndId?.[organizationId] || {}),
          [invitationId]: invitation
        }
      }
    };
  }),

  on(OrganizationsActions.resendOrganizationInvitationSuccess, (state, { organizationId, invitationId, resentAt }) => ({
    ...state,
    invitationResentAtByOrgId: {
      ...state.invitationResentAtByOrgId,
      [organizationId]: {
        ...(state.invitationResentAtByOrgId?.[organizationId] || {}),
        [invitationId]: resentAt
      }
    }
  })),

  on(OrganizationsActions.cancelOrganizationInvitationSuccess, (state, { organizationId, invitationId }) => {
    const prevInvitations = state.invitationsByOrgId?.[organizationId] || [];
    const newInvitationsByOrgId = {
      ...state.invitationsByOrgId,
      [organizationId]: prevInvitations.filter(inv => inv.id !== invitationId)
    };

    const newInvitationByOrgAndId = { ...state.invitationByOrgAndId };
    if (newInvitationByOrgAndId[organizationId]) {
      const newOrgInvitations = { ...newInvitationByOrgAndId[organizationId] };
      delete newOrgInvitations[invitationId];
      newInvitationByOrgAndId[organizationId] = newOrgInvitations;
    }

    return {
      ...state,
      invitationsByOrgId: newInvitationsByOrgId,
      invitationByOrgAndId: newInvitationByOrgAndId
    };
  }),

  // Reset organization invitations state on logout or clearUserData
  on(AuthActions.logout, AuthActions.clearUserData, () => initialOrganizationInvitationsState)
);